import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class media
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.media = {};

/**
 * GET Endpoint `/media/{type}`
 * @param {string} media_type (kaltura, youtube, video)
 * @param {string} uuid
 * @param {ReachAPI.Security} security
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.media
 * @todo move to ReachAPI.signage
 */
ReachAPI.media.get = function (media_type, uuid, security) {
    media_type = media_type || 'null';
    uuid = uuid || 'null';

    var url = ReachAPI.server + '/signage/media/' + media_type + '/' + uuid;
    var params = {};
    var jqPromise;

    // add security data
    params = security.merge(params);

    jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved media details (' + media_type + ') from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug(
                'Retrieved media details (' + media_type + ') from the API',
                null,
                __fileline
            );
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve media details (' + media_type + ')',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
